<style scoped>
    .company-name{
        display: inline-block;
        vertical-align: middle;
        font-size: 18px;
        font-weight: bold;
    }
    table{
        border-collapse:collapse;
        border: 1px solid #dddee1;
        width: 100%;
        text-align: center;
    }
    table tr{
        border-bottom: 1px solid #dddee1;
    }
    table th, table td{
        border-right: 1px solid #dddee1;
        padding: 5px;
    }
    .log{
        padding: 5px 0;
    }
    .log-company{
        display: inline-block;
        width: 60px;
        text-align: right;
    }
    .log-count{
        display: inline-block;
        width: 50px;
    }
    .select-bank-container{
        padding: 10px;
        margin-bottom: 10px;
    }
    .fill-info-btn{
        color: #2d8cf6;
        text-decoration: underline;
        cursor: pointer;
    }
    .bank-card{
        display: block;
        margin: 5px;
        padding: 3px 6px;
        border: 1px solid #dddee1;
        border-radius: 4px;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .bank-card:hover{
        background: #e5e5e5;
    }
</style>
<template>
    <div>
        <div class="line text-center">
            <Button type="warning" @click="startQrScaner" icon="ios-barcode-outline" :loading="loading">开始扫描</Button>
            <i-input v-model="params.search" @on-enter="manualInput" @on-change="inputChange" style="width: 150px" placeholder="按编码录入"></i-input>
            <Button type="primary" @click="manualInput" :loading="loading">确定</Button>
        </div>
        <div class="line text-center">
            <Spin size="large" v-if="reloading"></Spin>
        </div>
        <div class="line">
            <div class="line" v-for="(company, index) in companies" :key="company.id">
                <div class="line" v-if="company.expense_groups.length">
                    <div class="line">
                        <span class="company-name">{{company.name}}</span>
                        <Button size="small" type="primary" @click="setBank(company)">导出</Button>
                        <span> 总金额 ￥{{getCompanyTotalPrice(company)}}</span>
                        <span> 共{{company.expense_groups.length}}单 </span>
                        <span class="float-right">
                        <Button size="small" type="error" @click="clearExpenseGroup(company)">清除所有</Button>
                    </span>
                    </div>
                    <Table :columns="expense_group_columns" :data="company.expense_groups" size="small"></Table>
                </div>

            </div>
        </div>

        <Modal
            title="设置银行信息"
            width="600"
            v-model="set_bank_config.modal"
            :loading="set_bank_config.loading"
            @on-ok="exportExpenseGroup(export_params.company)"
            ok-text="确定">
            <div class="line select-bank-container">
                <span v-html="getBankInfoHtml(export_params.expense_payment_bank_id)"></span>
                <span>
                    <Poptip placement="bottom-start" width="300">
                        <span ref="selectBankBtn" class="fill-info-btn">选择付款银行</span>
                        <div class="pop-tip-content" slot="content">
                            <div class="bank-card" v-for="bank in banks" v-if="showBank(bank)" :key="bank.id" @click="selectBank(bank)">
                                <div>
                                    <span>{{bank.bank}} - </span>
                                    <span>{{bank.account}}</span>
                                </div>
                                <div>
                                    <span>{{bank.bank_number}} - </span>
                                    <span>{{bank.bank_branch}}</span>
                                </div>
                            </div>
                        </div>
                    </Poptip>
                </span>
            </div>
        </Modal>
    </div>
</template>
<script>
    import ExportBase from '../mixins/expense_group_export_to_pay_base';
    export default {
        mixins: [ExportBase],
        data () {
            return {
                //
            }
        },
        computed: {
            //
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            showBank(bank) {
                return !bank.del && bank.company_id === this.export_params.company.id;
            }
        }
    }
</script>
